import { LogoSplash } from "../../../config/brandAssets";

interface LogoImageProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  appIcon?: string | null;
  appIconColor?: string;
}

const sizeClasses = {
  sm: "w-7 h-7",
  md: "w-8 h-8",
  lg: "w-10 h-10",
};

const markClasses = {
  sm: "w-5 h-5",
  md: "w-6 h-6",
  lg: "w-7 h-7",
};

const overlayClasses = {
  sm: "w-3 h-3 -right-1 -bottom-1",
  md: "w-4 h-4 -right-1.5 -bottom-1.5",
  lg: "w-5 h-5 -right-2 -bottom-2",
};

const overlayIconSizes = {
  sm: "text-[8px]",
  md: "text-[10px]",
  lg: "text-xs",
};

const maskStyle = {
  maskImage: `url(${LogoSplash})`,
  WebkitMaskImage: `url(${LogoSplash})`,
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
  maskPosition: "center",
  WebkitMaskPosition: "center",
  maskSize: "contain",
  WebkitMaskSize: "contain",
} as const;

export default function LogoImage({ size = "md", className = "", appIcon, appIconColor }: LogoImageProps) {
  const containerClass = sizeClasses[size];
  const markClass = markClasses[size];
  const overlayClass = overlayClasses[size];
  const overlayIconSize = overlayIconSizes[size];

  return (
    <div className={`relative flex-shrink-0 ${className}`}>
      <div
        className={`${containerClass} bg-primary-500 rounded-xl flex items-center justify-center overflow-visible`}
      >
        <span
          role="img"
          aria-label="Logo"
          className={`${markClass} block bg-on-primary`}
          style={maskStyle}
        />
      </div>
      {appIcon && appIconColor && (
        <div
          className={`absolute ${overlayClass} ${appIconColor} rounded flex items-center justify-center shadow-md`}
        >
          <i className={`${appIcon} text-white ${overlayIconSize}`} />
        </div>
      )}
    </div>
  );
}
